const baseUrl = process.env.REACT_APP_BASE_URL;
const baseUrlErp = process.env.REACT_APP_ERP_URL;
const baseUrlAutoassigned = process.env.REACT_APP_AUTOASSIGNED_URL;
const BASE_TOKEN = process.env.REACT_APP_BASE_TOKEN;
const ERP_TOKEN = process.env.REACT_APP_ERP_TOKEN;

const fetchSinToken = (endpoint, data, method = "GET") => {
  const url = `${baseUrl}/${endpoint}`;
  const token = `Bearer ${BASE_TOKEN}`;

  if (method === "GET") {
    return fetch(url, {
      method,
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
    });
  } else {
    return fetch(url, {
      method,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(data),
    });
  }
};

const fetchConToken = (endpoint, data, method = "GET") => {
  const url = `${baseUrl}/${endpoint}`;
  const token = `Bearer ${localStorage.getItem("token-adm")}`;

  if (method === "GET") {
    return fetch(url, {
      method,
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
    });
  } else {
    return fetch(url, {
      method,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(data),
    });
  }
};

const fetchConTokenErp = (endpoint, data, method = "GET") => {
  const url = `${baseUrlErp}/${endpoint}`;
  const token = `Bearer ${ERP_TOKEN}`;

  if (method === "GET") {
    return fetch(url, {
      method,
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
    });
  } else {
    return fetch(url, {
      method,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(data),
    });
  }
};

const fetchAutoassigned = (endpoint, data, method = "GET") => {
  const url = `${baseUrlAutoassigned}/${endpoint}`;
  const token = `Bearer ${ERP_TOKEN}`;

  if (method === "GET") {
    return fetch(url, {
      method,
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
    });
  } else {
    return fetch(url, {
      method,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(data),
    });
  }
};

const fetchNotification = (endpoint, data, method = "GET") => {
  const url = `${baseUrl}${endpoint}`;

  if (method === "GET") {
    return fetch(url);
  } else {
    return fetch(url, {
      method,
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
  }
};

export {
  fetchSinToken,
  fetchConToken,
  fetchNotification,
  fetchConTokenErp,
  fetchAutoassigned,
};
